import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'src/utils/AxiosConfig';

// ** Fetch Projects
export const getProjects = createAsyncThunk('appProjects/getProjects', async (params) => {
  const response = await axios.get('/api/projects', { ...params })
  return response.data
})

// ** Fetch single Project
export const getSingleProjects = createAsyncThunk('appProjects/getSingleProjects', async (id) => {
  const response = await axios.get(`/api/projects/${id}`)
  return response.data
})

// ** Add Project
export const addProject = createAsyncThunk(
  'appProjects/addProject',
  async (data, { getState, dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post('/api/projects', { ...data })
      return response.data
    } catch (error) {
      // Reject with the error message or any other error details you want
      return rejectWithValue(error.response ? error.response.data : error.message)
    }
  }
)

export const updateProject = createAsyncThunk(
  'appProjects/updateProject',
  async ({ id, ...data }, { getState, dispatch, rejectWithValue }) => {
    try {
      const response = await axios.put(`/api/projects/${id}`, { ...data })
      return response.data
    } catch (error) {
      // Reject with the error message or any other error details you want
      return rejectWithValue(error.response ? error.response.data : error.message)
    }
  }
)

// ** Delete Project
export const deleteProject = createAsyncThunk('appProjects/deleteProject', async (id, { getState, dispatch }) => {
  const response = await axios.delete(`/api/projects/${id}`)
  dispatch(getProjects(getState().project.params)) // Refresh project list after deletion
  return response.data
})

export const appProjectSlice = createSlice({
  name: 'appProjects',
  initialState: {
    singleData: {},   // Data for a single Project
    data: [],         // Data for a list of Projects
    total: 0,
    params: {},
    allData: [],      // (Optional) Store all Project data if needed
    status: 'idle',
    message: null,
    errors: null
  },
  reducers: {
    resetSingleProject: (state) => {
      state.singleData = {}; // Reset single Project data
    },
    resetStateIdele: (state) => {
      state.status = 'idle'; // Reset single Project data
    }
  },
  extraReducers: (builder) => {
    // ** Fetch Multiple Projects
    builder
      .addCase(getProjects.pending, (state) => {
        state.status = 'loading'
        state.message = null;
        state.errors = null
      })
      .addCase(getProjects.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.data = action.payload.data
        state.total = action.payload.total
        state.params = action.payload.params
      })
      .addCase(getProjects.rejected, (state, action) => {
        state.status = 'failed'
        // state.message = action.payload.message
        // state.errors = action.payload.errors
      })

    // ** Add Project
    builder
      .addCase(addProject.pending, (state) => {
        state.status = 'loading'
        state.message = null;
        state.errors = null
      })
      .addCase(addProject.fulfilled, (state) => {
        state.status = 'succeeded'
      })
      .addCase(addProject.rejected, (state, action) => {
        state.status = 'failed'
        state.message = action.payload?.message
        state.errors = action.payload?.errors
      })

    builder
      .addCase(updateProject.pending, (state) => {
        state.status = 'loading'
        state.message = null;
        state.errors = null
      })
      .addCase(updateProject.fulfilled, (state) => {
        state.status = 'succeeded'
      })
      .addCase(updateProject.rejected, (state, action) => {
        state.status = 'failed'
        state.message = action.payload?.message
        state.errors = action.payload?.errors
      })

    // ** Delete Project
    builder
      .addCase(deleteProject.pending, (state) => {
        state.status = 'loading'
        state.message = null;
        state.errors = null
      })
      .addCase(deleteProject.fulfilled, (state) => {
        state.status = 'succeeded'
      })
      .addCase(deleteProject.rejected, (state, action) => {
        state.status = 'failed'
        state.message = action.payload?.message
        state.errors = action.payload?.errors
      })

    // ** Fetch Single Project
    builder
      .addCase(getSingleProjects.pending, (state) => {
        state.status = 'loading'
        state.message = null;
        state.errors = null
      })
      .addCase(getSingleProjects.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.singleData = action.payload.data
      })
      .addCase(getSingleProjects.rejected, (state, action) => {
        state.status = 'failed'
        state.message = action.payload?.message
        state.errors = action.payload?.errors
      })
  }
})

export const { resetSingleProject, resetStateIdele } = appProjectSlice.actions;



export default appProjectSlice.reducer
